module.exports = __webpack_public_path__ + "img/Bent Bracelet.00853165.png";